module.exports = __webpack_public_path__ + "img/background-voucher-landing-mobile.b1240f0.png";